import React from "react";
import nonCheck from "../assets/icons/RadioNonCheckedIcon.svg";
import user from "../assets/images/user.png";
import insta from "../assets/icons/insta.svg";
import { BsArrowReturnRight } from "react-icons/bs";
import { PiTranslateBold } from "react-icons/pi";
import Button from "./Button";

const SyncContent = () => {
  return (
    <>
      <p className="text-[#9392A2] text-sm font-medium leading-snug tracking-normal">You can sync content all across your <br /> profiles in terms of account group.</p>
      <div className="p-3 bg-white rounded-xl mt-3 mb-2">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-2.5">
              <img src={user} className="w-10 h-10 rounded-full" alt="workspace" />
              <div>
                <div className="text-[#0F0C18] text-base font-medium tracking-tight">Andrew Wack</div>
                <div className="text-[#9392A2] text-xs font-medium tracking-tight">3 accounts undernce</div>
              </div>
            </div>
            <img src={nonCheck} alt="nonCheck" />
          </div>
          <div className="mt-3.5 flex items-start gap-[22px]">
            <BsArrowReturnRight className="w-4 h-4 ml-3 text-[#9392A2]" />
            <div className="w-full flex flex-col gap-3">
              <div className="flex justify-between">
                <div className="flex gap-2">
                  <div className="flex">
                    <img src={insta} className="w-4 h-4 rounded-full" alt="fb" />
                    <img src={user} className="w-4 h-4 rounded-full -ml-1.5" alt="fb" />
                  </div>
                  <p className="text-[#0F0C18] text-xs font-medium tracking-tight">3 social networks</p>
                </div>
                <div className="flex gap-2">
                  <div className="flex gap-1">
                    <PiTranslateBold className="text-xs"/>
                    <p className="text-[#9392A2] text-xs font-medium tracking-tight">English</p>
                  </div>
                  <img src={nonCheck} alt="nonCheck" />
                </div>
              </div>
              <div className="flex justify-between">
                <div className="flex gap-2">
                  <div className="flex">
                    <img src={insta} className="w-4 h-4 rounded-full" alt="fb" />
                    <img src={user} className="w-4 h-4 rounded-full -ml-1.5" alt="fb" />
                  </div>
                  <p className="text-[#0F0C18] text-xs font-medium tracking-tight">3 social networks</p>
                </div>
                <div className="flex gap-2">
                  <div className="flex gap-1">
                    <PiTranslateBold className="text-xs"/>
                    <p className="text-[#9392A2] text-xs font-medium tracking-tight">English</p>
                  </div>
                  <img src={nonCheck} alt="nonCheck" />
                </div>
              </div>
              <div className="flex justify-between">
                <div className="flex gap-2">
                  <div className="flex">
                    <img src={insta} className="w-4 h-4 rounded-full" alt="fb" />
                    <img src={user} className="w-4 h-4 rounded-full -ml-1.5" alt="fb" />
                  </div>
                  <p className="text-[#0F0C18] text-xs font-medium tracking-tight">3 social networks</p>
                </div>
                <div className="flex gap-2">
                  <div className="flex gap-1">
                    <PiTranslateBold className="text-xs"/>
                    <p className="text-[#9392A2] text-xs font-medium tracking-tight">English</p>
                  </div>
                  <img src={nonCheck} alt="nonCheck" />
                </div>
              </div>
            </div>
          </div>
      </div>
      <Button label="Confirm" className="mt-6" />
    </>
  );
};

export default SyncContent;